import { Addresses, Id } from '@typings';

import { ShippingAddressCard } from './ShippingAddressCard';

interface Props {
  accountId: Id;
  shippingAddresses: Addresses.Shipping[];
  isLoading?: boolean;
  onRowEdit: (shippingAddressId: string) => void;
}

export const ShippingAddressCards = ({ accountId, shippingAddresses, isLoading, onRowEdit }: Props) => {
  return (
    <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
      {shippingAddresses.map((shippingAddress, index) => (
        <ShippingAddressCard
          key={index}
          accountId={accountId}
          isLoading={isLoading}
          shippingAddresses={shippingAddresses}
          shippingAddress={shippingAddress}
          onEdit={onRowEdit}
        />
      ))}
    </div>
  );
};
